import React from "react";

interface Props {
  address: server.dto.Address | string[]
}

const FormattedAddress = (props: Props) => {
  const addressLines = Array.isArray(props.address) ? props.address : props.address.formatted;
  return <>
    {addressLines.map((line, i) =>
      <div key={`${i}|${line}`}>
        {line}
      </div>)}
  </>;
};

export default FormattedAddress;